import React, { useState, useRef, useContext } from "react";
import { ManageTempMapLayout } from "../../../components";
import { Button, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import FileInfo from "./FileInfo";
import {
  getPathWithParam,
  MANAGE_PAYROLL_ROUTES,
  manageMapperFormNames,
  mapperFormFields,
  FLOW_TYPES,
  ROUTES,
} from "../../../utils";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import {
  manageMapperStore,
  setManageMapperToastInfo,
  setManageMapperPageLevelData,
  setMapperPageLevelData,
  MANAGE_MAPPER_POST_API_ERROR,
  TempMappingUploadSourceFile,
} from "../../../contexts";
import { LoaderWrapper } from "../../../components";
import { Formik } from "formik";
import { get, isEmpty, values } from "lodash";
import * as Yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";

const initialValues = {};

const BasicInformationContainer = (props) => {
  const [newFile, setNewFile] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { state, dispatch } = useContext(manageMapperStore);
  const fileName =
    get(state, "api.fileuploadData.mappingConfiguration.fileName") ||
    get(state, "api.data.fileName");
  const formValues = get(state, "api.fileuploadData")
    ? get(state, "api.fileuploadData.mappingConfiguration", {})
    : get(state, "api.data", {});
  const [previousFile, setPreviousFile] = useState("");
  const [isSubmitsucces, setIsSubmitsucces] = useState(null);
  const formName = manageMapperFormNames.SOURCE;
  const fields = mapperFormFields[formName];
  const [dataLoading, setDataLoading] = useState(false);
  const editable = formValues.step ? true : false;
  const config = !isEmpty(formValues)
    ? JSON.parse(get(formValues, "configurationJson"))
    : "";
  const [isResponseFailed, setIsResponseFailed] = useState(true);

  const apiFormat = get(state, "api.data.format", 3);
  const uploadFormat = get(
    state,
    "api.fileuploadData.mappingConfiguration.format",
    3
  );
  const basicInformation = {
    mapType: 1,
    isOutput: false,
    createdBy: 1,
  };

  const fileFormatCheck = () => {
    if (!isEmpty(get(state, "api.fileuploadData", [])) && isResponseFailed) {
      return uploadFormat;
    } else if (
      isEmpty(get(state, "api.fileuploadData", [])) &&
      isResponseFailed
    ) {
      if (
        !isEmpty(
          get(state, "api.fileuploadData.mappingConfiguration.format", [])
        )
      ) {
        return uploadFormat;
      } else {
        return apiFormat;
      }
    } else if (
      !isEmpty(get(state, "api.fileuploadData", [])) &&
      !isResponseFailed
    ) {
      return uploadFormat;
    } else {
      return apiFormat;
    }
  };
  const stepCheck = get(formValues, "step") == 0;
  const { flow, profileId } = useRouterParams();
  const isEdit = flow === FLOW_TYPES.EDIT;
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.PAYROLL,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];
  const [fileUploadRequired, setFileUploadRequired] = useState("");
  const [clearField, setClearField] = useState(false);
  const [uploadSourceFile, setUploadSourceFile] = useState();
  useDeepEffect(() => {
    if (!isEmpty(fileName) && !isEmpty(newFile)) {
      setIsModalOpen(true);
    }
  }, [newFile]);

  const onDeleteConfirmClick = () => {
    setIsModalOpen(false);
  };

  const handleClose = () => {
    setClearField(true);
    setIsModalOpen(false);
  };
  const showError = (values) => {
    const filenameArray = values[fields.uploadSourceFile]
      ? values[fields.uploadSourceFile][0].name.split(".")
      : get(state, "api.data.fileName").split(".");
    switch (values[fields.fileFormat]) {
      case 1:
        if (values[fields.uploadSourceFile][0].name.split(".")[1] != "csv") {
          setFileUploadRequired("*Please upload a valid csv file.");
        }
        break;
      case 2:
        if (
          filenameArray[filenameArray.length - 1] != "txt" &&
          filenameArray[filenameArray.length - 1] != "yaml"
        ) {
          setFileUploadRequired("*Please upload a valid text file.");
        }
        break;
      case 3:
        if (
          filenameArray[filenameArray.length - 1] != "xlsx" &&
          filenameArray[filenameArray.length - 1] != "xls"
        ) {
          setFileUploadRequired("*Please upload a valid excel file.");
        }
        break;
      default:
        setFileUploadRequired("*Please upload a valid excel/csv file.");
        break;
    }
    scrollToBottom();
  };

  const onFormSubmit = (values) => {
    setDataLoading(true);
    const { history } = props;
    if (isEmpty(fileName) && isEmpty(values[fields.uploadSourceFile])) {
      setFileUploadRequired(
        "Required . Please upload a file in order to create a profile."
      );
      setDataLoading(false);
    } else if (!isEmpty(fileName) && isEmpty(values[fields.uploadSourceFile])) {
      if (!fileUploadRequired) {
        history.push(
          values[fields.fileFormat] === 2
            ? history.push(
                `${MANAGE_PAYROLL_ROUTES.FIXED_LENGTH}/${
                  isEdit ? "edit" : null
                }/${profileId}`
              )
            : getPathWithParam({
                path: MANAGE_PAYROLL_ROUTES.MAP_AND_TRANSFORM,
                pathParam: [FLOW_TYPES.ADD, profileId],
              })
        );
      }
    } else {
      showError(values);
    }
    const configure =
      values[fields.fileFormat] === 1
        ? {
            delimiter: values[fields.delimiter],
            commentCharacter: "#",
            headerRow: values[fields.contentStartsFrom],
            hasHeader: values[fields.hasHeader],
            allowNull: values[fields.checkForHeaderCountMismatch],
          }
        : values[fields.fileFormat] === 3
        ? {
            spreadSheetToRead: values[fields.selectDataFrom],
            spreadSheetName: values[fields.spreadSheetName],
            headerRow: values[fields.contentStartsFrom],
            hasHeader: values[fields.hasHeader],
            allowNull: values[fields.checkForHeaderCountMismatch],
            spreadSheetNumber: values[fields.spreadSheetNumber],
          }
        : {
            recordLength: values[fields.recordLength],
          };

    TempMappingUploadSourceFile(
      { basicInformation, values, configure },
      dispatch
    )
      .then((res) => {
        var pid = res.mappingConfiguration.id;
        setDataLoading(false);
        setFileUploadRequired(res.errormessage ? res.errormessage : "");
        if (res.isSuccess) {
          if (!isEdit) {
            dispatch(
              setMapperPageLevelData({
                formName: formName,
                fieldData: values,
                format: values[fields.fileFormat],
              })
            );
          }
          dispatch(
            setManageMapperPageLevelData({
              formName: "objectMaps",
              fieldData: get(res, "mappingConfiguration.objectMaps", []),
            })
          );
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
          window.setTimeout(() => {
            history.push(
              values[fields.fileFormat] === 2
                ? history.push(`${MANAGE_PAYROLL_ROUTES.FIXED_LENGTH}/${pid}`)
                : getPathWithParam({
                    path: MANAGE_PAYROLL_ROUTES.MAP_AND_TRANSFORM,
                    pathParam: [FLOW_TYPES.ADD, pid],
                  })
            );
          }, 10);
        } else {
          setIsSubmitsucces(false);
          showError(values);
          setIsResponseFailed(false);
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
        }
      })
      .catch((err) => {
        setDataLoading(false);
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
  };

  const ValidationSchema = Yup.object().shape({
    sourceUrl: Yup.string().when("fileType", {
      is: 1,
      then: Yup.string().required("URL Required"),
    }),
    sourceUserName: Yup.string().when("fileType", {
      is: 1,
      then: Yup.string().required("Username Required"),
    }),
    sourcePassword: Yup.string().when("fileType", {
      is: 1,
      then: Yup.string().required("Password Required"),
    }),
    spreadSheetNumber: Yup.string().when("selectDataFrom", {
      is: 3,
      then: Yup.string().required("Required"),
    }),
    spreadSheetName: Yup.string().when("selectDataFrom", {
      is: 4,
      then: Yup.string().required("Required"),
    }),
    contentStartsFrom: Yup.string()
      .required("Required")
      .test(
        "Is positive?",
        "The number must be greater than 0",
        (value) => value > 0
      ),
    uploadSourceFile: Yup.array().test(
      "Is positive?",
      "Required",
      (val) => !checkFile(val)
    ),
  });
  const checkFile = (val) => {
    if (val === undefined) {
      setFileUploadRequired(
        "Required . Please upload a file in order to create a profile."
      );
      return false;
    }
  };
  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
        uploadSourceFile: uploadSourceFile,
        [fields.fileType]: 0,
        [fields.uploadedFileType]: get(
          state,
          "api.fileuploadData.mappingConfiguration.uploadedFileType",
          3
        ),
        [fields.fileFormat]: fileFormatCheck() || 3,
        [fields.selectDataFrom]: get(config, "spreadSheetToRead", 1),
        [fields.hasHeader]: get(config, "hasHeader", true),
        [fields.checkForHeaderCountMismatch]: true,
        [fields.contentStartsFrom]: get(config, "headerRow", 1),
        [fields.spreadSheetName]: get(config, "spreadSheetName", ""),
        [fields.spreadSheetNumber]: get(config, "spreadSheetNumber", 1),
        [fields.delimiter]: get(config, "delimiter", ","),
        [fields.recordLength]: get(config, "recordLength", ""),
      }}
      enableReinitialize
      onSubmit={onFormSubmit}
      validationSchema={ValidationSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        errors,
        values,
        touched,
        setErrors,
        setValues,
        handleChange,
        setFieldValue,
        handleSubmit,
      }) => {
        const clearFiles = () => {
          setFieldValue(fields.uploadSourceFile, undefined);
          setNewFile([]);
        };
        return (
          <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
            <LoaderWrapper isLoading={dataLoading}>
              <ManageTempMapLayout layoutHeader="Source" buttons={buttons}>
                <div>
                  <FileInfo
                    setErrors={setErrors}
                    values={values}
                    isSubmitsucces={isSubmitsucces}
                    previousFile={previousFile}
                    setPreviousFile={setPreviousFile}
                    setFileUploadRequired={setFileUploadRequired}
                    setFieldValue={setFieldValue}
                    fields={fields}
                    isEdit={isEdit}
                    editable={editable}
                    newFile={newFile}
                    fileName={fileName}
                    setNewFile={setNewFile}
                    clearField={clearField}
                    setClearField={setClearField}
                    fileUploadRequired={fileUploadRequired}
                    state={state}
                    formName={formName}
                  />
                  <div ref={messagesEndRef}></div>
                </div>

                <Modal show={isModalOpen} onHide={handleClose}>
                  <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                    <div className="text-right">
                      <FontAwesomeIcon
                        icon={faTimes}
                        color="#000"
                        onClick={() => setIsModalOpen(false)}
                      />
                    </div>
                    <div className="d-flex">
                      <div className="pd-15">
                        <FontAwesomeIcon
                          icon={faExclamationTriangle}
                          color="#f94f50"
                          size="3x"
                        />
                      </div>
                      <div className="remove-text">
                        <h4>New File Detected </h4>
                        <p>
                          Are you sure ? Some of your mapped fields will be
                          deleted.. Do you want to continue ?
                        </p>

                        <Button
                          className="remove-btn mr-4"
                          onClick={onDeleteConfirmClick}
                        >
                          Yes
                        </Button>
                        <Button
                          className="cancel-btn"
                          onClick={() => {
                            handleClose();
                            clearFiles();
                          }}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              </ManageTempMapLayout>
            </LoaderWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default BasicInformationContainer;
